import { injectable } from "inversify";
import events from "../../events/EventsObservable";
import { GAME_EVENTS } from "../../game/gameEvents";

export const PAUSE_OVERLAY_ID = "mxPauseOverlay";

/**
 * Transparent fullscreen layer shown while the wrapper has the game paused.
 * It swallows every pointer event so neither the engine canvas nor the DOM
 * controls receive input. Engine-agnostic: no game or engine code involved.
 * Keyboard input is gated separately in AbstractUIActions.isActionAllowed.
 */
@injectable()
export default class PauseOverlay {
	private element: HTMLElement | null = null;

	init(): void {
		events.subscribe(GAME_EVENTS.GAME_PAUSED, (_: string, paused: boolean) => {
			this.setVisible(paused);
		});
	}

	setVisible(visible: boolean): void {
		this.getElement().hidden = !visible;
	}

	isVisible(): boolean {
		return this.element !== null && !this.element.hidden;
	}

	private getElement(): HTMLElement {
		if (this.element) return this.element;

		const element = document.createElement("div");
		element.id = PAUSE_OVERLAY_ID;
		element.classList.add("mx-pause-overlay");
		element.hidden = true;
		document.body.appendChild(element);

		this.element = element;
		return element;
	}
}
